<template src="./finalyticIntegrationDetail.template.html"></template>
<script>
    import moment from "moment-timezone";
    import * as axios from "axios";
    import VeeValidate from "vee-validate";
    import Vue from "vue";
    import foliomodal from "../../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue"
    Vue.use(VeeValidate);
    export default {
        components: {
            foliomodal
        },
        name: "finalyticIntegrationDetail",
        props: ["closeFinalyticAccoutPanel", "unitId", "propertyId", "getIntegrationList", "componentIntegrationId", "integrationName"],
        data() {
            return {
                wheelHouseIntegratedUsersList: [],
                ratePlanList: [],
                SelectedwheelHouseUser: {},
                clientDetails: {},
                selectedFinalyticUser: {},
                finalyticIntegratedUsersList: [],
                finalyticAccountDetails: {},
                parentClassList: []
            }
        },

        methods: {
            GetRateplanList() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_RatePlanList",
                    params: {
                        ModuleAction: "Get_RatePlanList",
                        StatusId: 1,
                        SearchText: null,
                        Tagtext: null
                    },
                    callback: function (err, response) {

                        if (err) {
                            return
                        }
                        if (response) {
                            console.log("GetRateplanList", response)
                            vm.ratePlanList = response[1]

                        }
                    }
                })
            },
            saveConnectionDetails() {
                let vm = this;
                console.log("save-fina--", vm.finalyticAccountDetails);
                vm.$validator.validateAll().then((result) => {
                    if (result) {
                        vm.$store.dispatch("dataRequestHandler", {
                            key: "SaveIntegrations",
                            params: {
                                ModuleAction: "SaveIntegrations",
                                crsId: null,
                                // ClientCode: null,
                                username: vm.finalyticAccountDetails.UserName,
                                password: vm.finalyticAccountDetails.Password || null,
                                statusId: 1,
                                isDefault: true,
                                UnitId: null,      //vm.unitId,
                                PropertyId: null, // vm.propertyId,
                                UsersPassword: null,
                                User_ApiKey: vm.finalyticAccountDetails.User_ApiKey,
                                RatePlanId: null,
                                IntegrationId: vm.$route.params.integrationId ? vm.$route.params.integrationId : vm.componentIntegrationId,
                                EmailId: null,
                                Integrators_UserId: vm.finalyticAccountDetails.Integrators_UserId,
                                PhoneNumber: null,
                                derivedRateplanId: null,
                                Amount: null,
                                isPercentage: null,
                                isPositive: null,
                                PaymentConnectionId: vm.finalyticAccountDetails.PaymentConnectionId,
                                RefreshToken: vm.finalyticAccountDetails.RefreshToken,
                                IntegartedClientId: vm.finalyticAccountDetails.IntegartedClientId,
                                classid: vm.finalyticAccountDetails.IntegratedClassId
                            },
                            callback: function (err, response) {

                                if (err) {
                                    vm.$store.dispatch("toastr", {
                                        type: "error",
                                        header: "Error!",
                                        message: "Error in creating user"
                                    });
                                    return
                                }
                                if (response) {
                                    if (response.recordsets && response.recordsets[0] && response.recordsets[0][0] && response.recordsets[0][0].ErrorMessage) {
                                        vm.$store.dispatch("toastr", {
                                            type: "error",
                                            message: response.recordsets[0][0].ErrorMessage,
                                            header: "Error!"
                                        });
                                    } else {
                                        console.log("user fin--inactive = ", response)
                                        vm.$store.dispatch("toastr", {
                                            type: "success",
                                            header: "Success!",
                                            message: "Account Added Successfully!!"
                                        });
                                        vm.closeFinalyticAccoutPanel();
                                    }
                                    vm.getIntegrationList();

                                    vm.GetFinalyticUserList();
                                }
                            }
                        })
                    }
                    else {
                        vm.$store.dispatch("toastr", {
                            type: "warning",
                            header: "warning!",
                            message: "Enter the integration details"
                        });
                    }
                })
            },
            GetFinalyticAccountDetails() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "Get_ListOfIntegrations_RU",
                    params: {
                        ModuleAction: "Get_ListOfIntegrations_RU",
                        PropertyId: null,
                        UnitId: null
                    },
                    callback: function (err, response) {
                        if (response[0].length) {
                            vm.finalyticAccountDetails = response[0].find(element =>{    
                                if(element.IntegrationId == 10){
                                    console.log('vm.$route.params', vm.$route.params);
                                    return element.IntegrationId == vm.$route.params.integrationId && element.IntegartedClientId == vm.$route.params.IntegartedClientId && element.RefreshToken == vm.$route.params.RefreshToken
                                }else{
                                    return element.IntegrationId == vm.$route.params.integrationId
                                }
                            }) || {}
                        }
                        console.log("vm.finalyticAccountDetails---get----", vm.finalyticAccountDetails)

                    }
                })
                setTimeout(() => {
                    vm.openWheelHouseComponent = false;
                }, 1000);
            },
            GetClassByClient() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetClassByClient",
                    params: {
                        ModuleAction: "GetClassByClient",
                    },
                    callback: function (err, response) {
                        if (response[0].length) {
                            vm.parentClassList = response[0]

                        }
                        console.log("vm.parentClassList---get----", vm.parentClassList)

                    }
                })
            },
            CreateNewClass() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "CreateNewClass",
                    params: {
                        ModuleAction: "CreateNewClass",
                    },
                    callback: function (err, response) {
                        if (response[0].length) {
                            vm.parentClassList = response[0]

                        }
                        console.log("vm.parentClassList---get----", vm.parentClassList)

                    }
                })
            },
            isFinalyticDetails() {
                console.log("finalyticAccountDetails----", this.finalyticAccountDetails, Object.keys(this.finalyticAccountDetails).length);
                return Object.keys(this.finalyticAccountDetails).length === 0;
            }



        },
        watch: {

        },
        computed: {},

        mounted() {
            let vm = this;
            console.log("before-vm.finalyticAccountDetails", vm.finalyticAccountDetails.UserName, vm.finalyticAccountDetails !== null)

            console.log("ount----", this.$route.params);
            vm.finalyticAccountDetails = this.$route.params
            if (vm.$route.params.integrationId) {
                vm.componentIntegrationId = vm.$route.params.integrationId
            }
            console.log("vm.finalyticAccountDetails", vm.integrationName)

            vm.GetFinalyticAccountDetails();
            vm.GetRateplanList();
            vm.isFinalyticDetails();
            vm.GetClassByClient();
        }
    };
</script>